<template>
  <component :is="component" />
</template>
<script>
import Func11ExtratoCoparticipacao from '@/views/11/Func11ExtratoCoparticipacao'

export default {
  name: 'Func11',
  data () {
    return {
      component: Func11ExtratoCoparticipacao
    }
  }
}
</script>
